<template>
    <div>
        <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

            <b-card bg-variant="light">

                <b-card bg-variant="light">
                    <div class="mb-2 d-flex align-items-center justify-content-center">
                        <strong>{{ itensSelecionados.length == 1 ? itensSelecionados[0].descricaoDepartamento : (
                            itensSelecionados.length + ' Unidades Administrativas') }}</strong>
                    </div>
                </b-card>

                <b-form-row @keyup.enter="save">

                    <b-col cols="12">
                        <b-form-group label="Cota mensal:*">

                            <b-form-input style="height: 20px;" v-model="quantidade" type="number" min="1"
                                required></b-form-input>
                        </b-form-group>
                    </b-col>


                    <b-col cols="3"></b-col>
                    <b-col cols="6" class="text-center">
                        <b-button v-b-tooltip.hover.top="'Salvar'" @click="save" id="salvar" class=" my-2" size="sm"
                            pill variant="success">
                            <b-icon icon="check-circle" />

                        </b-button>

                        <b-button v-b-tooltip.hover.top="'Limpar'" id="cancelar" class=" my-2 ml-2" size="sm" pill
                            variant="danger" @click="cancelar">
                            <b-icon icon="x-circle" />

                        </b-button>
                    </b-col>
                    <b-col cols="3"></b-col>
                </b-form-row>


            </b-card>

        </b-modal>
    </div>
</template>
<script>
import ResourceService from "@/core/api/ResourceService";
import { FormResourceMixin } from "@/core/mixins/resource";
import { ListResourceMixin } from "@/core/mixins/resource"

export default {
    components: {

    },
    mixins: [FormResourceMixin, ListResourceMixin],
    props: {
        produto: {
            type: Object,
            default: null,
        },
        itensSelecionados: {
            type: Array,
            default: () => [],
        },
        prefix: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            quantidade: 0,
            showModal: true,
            title: "Cadastro",


        };
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/configuracao-cota-departamento`);

    },
    methods: {

        async save() {
            this.quantidade = this.quantidade == "" || !this.quantidade ? 0 : this.quantidade;
            var form = [];
            this.itensSelecionados.forEach(element => {
                form.push({ id: element.id, departamento: { id: element.departamento}, quantidade: this.quantidade, produto: { id: this.produto.id } })
            });

            try {
                await this.$saveResource(form, "", false, {}, false, true);
                this.cancelar();

            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }


        },
        cancelar() {
            this.$emit("close");
        },

    },
};
</script>
